<template>
    <div class="m-dialog-wrapper">
        <div class="m-dialog">
            <div class="m-content">
                <div v-if="!!(title || desc)">
                    <div class="title" v-if="title">{{title}}</div>
                    <div class="desc" v-if="desc">{{desc}}</div>
                    <a :href="btnLink" class="u-dialog-btn" v-if="btnTxt" @click="close">{{btnTxt}}</a>
                </div> 

                <slot v-if="!(title || desc)"></slot>
            </div>
            <img src="../../assets/images/close.png" v-if="!closeImg" class="u-btn-close" @click="close">

        </div>
    </div>
</template>
<script>
export default {
  name: 'Dialog',
  data () {
      return {
          closeImg:'../../assets/images/close.png',
          title:'',
          desc:'',
          btnLink:'',
          btnTxt:''
      }
  },
  computed:{
  },
  props:['params'],
  methods: {
      close(){
          this.show = false;
          this.$emit('listenDialog',{isShow:false});
      }
  },
  updated(){
      this.title = this.params.title;
      this.desc = this.params.desc;
      this.btnLink = this.params.btnLink;
      this.btnTxt = this.params.btnTxt;
  },
  mounted(){
      this.title = this.params.title;
      this.desc = this.params.desc;
      this.btnLink = this.params.btnLink;
      this.btnTxt = this.params.btnTxt;
  }
}
</script>
<style scoped>
    div,h3,p,span,a,img{padding:0;margin:0;box-sizing: border-box;}
    .m-dialog-wrapper{position: fixed;z-index: 100;width:100%;height: 100%;top:0;left:0;background-color: rgba(0,0,0,0.7)}
    .m-dialog{width:300px;position: absolute;top:50%;left:50%;transform: translate(-50%,-50%);text-align:center;}
    .m-content{width:100%;background-color:#ffffff;padding:20px;color:#666;text-align: center;font-size: 14px;}
    .title{font-size: 20px;line-height: 72px;}
    .u-dialog-btn{font-size: 18px;background:#00B9FF;width: 100px;height: 36px;line-height: 36px;border-radius: 4px;color: #fff;display: inline-block;margin-top: 20px;}
    /* .u-dialog-btn{margin-top:32px;height: 80px;display:inline-block;line-height: 80px;color:#fff;background-color:#ff4000;border-radius: 40px;width:66.6%;text-decoration: none;} */
    .u-btn-close{width: 9.4%;margin-top:40px;}
</style>

